
import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { actionButtons } from './navItems';

interface ActionButtonsProps {
  mounted: boolean;
  theme: string;
  onThemeToggle: () => void;
  onSearchOpen: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  mounted,
  theme,
  onThemeToggle,
  onSearchOpen
}) => {
  return (
    <div className="flex items-center gap-1 sm:gap-2 lg:gap-4">
      {/* Search Button */}
      <Button
        variant="ghost"
        size="icon"
        onClick={onSearchOpen}
        className="h-11 w-11 lg:w-auto lg:px-3 rounded-full hover:bg-secondary/80 transition-all duration-200 group"
        aria-label="Open search"
      >
        <Search className="h-4 w-4 text-muted-foreground group-hover:text-primary transition-colors" />
        <span className="hidden lg:block text-sm text-muted-foreground group-hover:text-foreground">
          Search
        </span>
        <div className="hidden lg:flex items-center space-x-1 text-xs text-muted-foreground">
          <kbd className="px-1.5 py-0.5 bg-muted rounded text-xs">⌘</kbd>
          <kbd className="px-1.5 py-0.5 bg-muted rounded text-xs">K</kbd>
        </div>
      </Button>

      {/* Action Buttons */}
      <div className="hidden lg:flex items-center space-x-3">
        {actionButtons.map((button) => (
          <Link key={button.label} to={button.href}>
            <Button
              variant={button.variant}
              size="default"
              className={`text-sm px-4 py-2 transition-all duration-200 ${button.className}`}
            >
              {button.label}
            </Button>
          </Link>
        ))}
      </div>
    </div>
  );
};
